let config = {
    "zuoxi": 2,
   // "xx": 60,
};
export default function timer(bus) {
    let timerManger = {};
    setInterval(function () {
        for (let k in config) {
            let lastTime = timerManger[k];
            if (typeof lastTime == "undefined") {
                timerManger[k] = new Date();
            } else {
                let cha =   (new Date()).getTime()-timerManger[k].getTime();

                if (cha >= config[k]*1000) {
                    bus.$emit(k);
                    timerManger[k] = new Date();
                }
            }
        }

    }, 1000);
}